import { render } from "./FloatingCartButton.vue?vue&type=template&id=673b890f&scoped=true"
import script from "./FloatingCartButton.vue?vue&type=script&lang=js"
export * from "./FloatingCartButton.vue?vue&type=script&lang=js"

import "./FloatingCartButton.vue?vue&type=style&index=0&id=673b890f&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673b890f"]])

export default __exports__